<template>
  <div>
    <!-- <el-row><label class="el-form-item__label">搜索条件配置</label></el-row> -->
    <el-form-item label="搜索条件配置" prop="search">
      <el-table
        :data="search">
        <el-table-column
          prop="name"
          label="条件名"
          width="120">
          <template scope="scope">
            <el-input class="w-100" v-model="scope.row.name" placeholder="请输入条件名"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型">
          <template scope="scope">
            <el-select
              v-model="scope.row.type"
              placeholder="无">
              <el-option
                v-for="item in searchTypes"
                :label="item.title"
                :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="filed_name"
          label="选择字段">
          <template scope="scope">
            <el-select
              v-model="scope.row.field_id">
              <el-option
                v-for="item in fields"
                :label="item.name + '(' + item.title + ')'"
                :value="item.field_id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="220">
          <template scope="scope">
            <el-button type="danger" size="small" @click="delConfig(scope.$index)">删除</el-button>
            <el-button size="small" type="primary" @click="sortUp(scope.$index)" :disabled="scope.$index == 0">上移</el-button>
            <el-button size="small" type="primary" @click="sortDown(scope.$index)" :disabled="scope.$index == search.length - 1">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>
    <div class="m-t-20 m-b-20">
      <el-button type="primary" @click="addConfig()">添加</el-button>
    </div>
  </div>
</template>

<script>
/**
 * props
 * @param [Array] search 搜索条件列表
 * @param [Array] fields 关联的字段列表
 * @param [Array] rules 规则
 */
  export default {
    props: {
      search: {
        type: Array,
        default: () => []
      },
      fields: {
        type: Array
      },
      rules: {}
    },
    data() {
      return {
        searchTypes: [
          { id: 10, title: '输入框' },
          { id: 20, title: '下拉框' },
          { id: 30, title: '范围搜索' },
          { id: 40, title: '时间控件' }
        ]
      }
    },
    created() {
      this.setRules()
    },
    methods: {
      /**
       * 设置必填规则
       */
      setRules() {
        if (this.rules && this.rules.search) {
          let validatePass = (rule, value, callback) => {
            if (value && value.length) {
              _(value).forEach((item) => {
                if (!item.name) {
                  callback(new Error('条件名不能为空'))
                } else if (!item.type) {
                  callback(new Error('类型不能为空'))
                } else if (!item.field_id) {
                  callback(new Error('选择字段不能为空'))
                }
              })
              callback()
            }
          }
          this.rules.search.push({
            validator: validatePass,
            trigger: 'change'
          })
          this.rules.search.push({
            validator: validatePass,
            trigger: 'blur'
          })
        }
      },
      addConfig() { // 添加配置
        this.search.push({
          name: '',
          type: '',
          field_id: ''
        })
      },
      delConfig(index) { // 删除配置
        this.search.splice(index, 1)
      },
      sortUp(index) { // 上移
        let config = this.search
        let temp = config[index]
        config.splice(index, 1)
        config.splice(index - 1, 0, temp)
      },
      sortDown(index) { // 下移
        let config = this.search
        let temp = config[index]
        config.splice(index, 1)
        config.splice(index + 1, 0, temp)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// searchConfig.vue?ca844922